import React from 'react'
import { scroller } from 'react-scroll'
import { Button, DropdownItem } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { Locations } from '@mc/track-event'
import { trackCTAClicked } from 'components/EnterpriseCTA/events'

interface CalloutProps {
  pageSource: string
  location: typeof Locations.NAVIGATION
  scrollToForm: boolean
  href: string
}

export const Callout = ({
  pageSource,
  location,
  scrollToForm,
  href,
}: CalloutProps) => {
  const { t } = useTranslation('@mc/next')

  const onCTAClick = () => {
    if (scrollToForm) {
      scroller.scrollTo('contact-form', {
        smooth: true,
        offset: -100,
      })
    }
    trackCTAClicked({
      action: 'Contact Us',
      page_source: pageSource,
      location,
    })
  }

  return (
    <div className='container d-flex flex-column flex-fill justify-content-end mc-pb-4 mc-text--center'>
      <div className='d-flex flex-column align-items-center mc-bg-container-tint-medium mc-py-4 mc-corners--md'>
        <h2 className='mc-text-h5 mc-mb-2'>
          {t('nav.mobileMenuCallout.title')}
        </h2>
        <p className='mc-mb-5'>{t('nav.mobileMenuCallout.subtitle')}</p>
        <DropdownItem
          closeOnClick
          className='d-flex justify-content-center mc-bg-hover-transparent'
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
        >
          <Button
            className='mc-w-fit-content mc-px-10'
            as='a'
            href={href}
            onClick={onCTAClick}
          >
            {t('nav.mobileMenuCallout.cta')}
          </Button>
        </DropdownItem>
      </div>
    </div>
  )
}

export default Callout
